import { render } from "./ringingMsgChoose.vue?vue&type=template&id=03d946c6&scoped=true"
import script from "./ringingMsgChoose.vue?vue&type=script&lang=js"
export * from "./ringingMsgChoose.vue?vue&type=script&lang=js"

import "./ringingMsgChoose.vue?vue&type=style&index=0&id=03d946c6&scoped=true&lang=css"

import exportComponent from "D:\\git\\tsunagaru-app\\public\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03d946c6"]])

export default __exports__